import React from "react";

const WrapAlign = ({ data, children }) => {
    if (!data?.align) return <>{children}</>;

    const alignCss =
        data.align === "Center"
            ? "justify-center"
            : data.align === "Right"
            ? "justify-end"
            : data.align === "Left"
            ? "justify-start"
            : "";

    return <div className={`flex ${alignCss}`}>{children}</div>;
};

export default WrapAlign;
